<script setup lang="ts">
  import AppShell from '@/components/layout/AppShell.vue';
  import Toast from 'primevue/toast';
  import ConfirmDialog from 'primevue/confirmdialog';
</script>

<template>
  <AppShell>
    <Toast position="top-right" />
    <ConfirmDialog />
    <RouterView />
  </AppShell>
</template>
